import React from 'react';
import { createContainer } from 'unstated-next';

function useUserState() {

  const [user, setUser] = React.useState(null);

  return {
    user,
    setUser,
  };
}

const User = createContainer(useUserState);

export const UserProvider = User.Provider;
export const useUser = User.useContainer;
